import react from "react";

const SocialLinkIcon = (props) => {
    const platform = props.platform.toLowerCase();
    let icon;
    switch(platform) {
        case "instagram":
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/instagram-icon.png";
            break;
        case "tiktok":
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/tiktok-icon.png";
            break;
        case "x":
             icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/x-icon.png";
            break;
        case "substack":
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/substack-icon.png";
            break;
        case "threads":
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/threads-icon.jpg";
            break;
        case "linkedin":
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/linkedin-icon.png";
            break;
        case "youtube":
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/youtube-icon.png";
            break;
        case "website":
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/website-icon.png";
            break;
        case "calendar":
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/calendar.png";
            break;
        case "email":
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/email-icon.png";
            break;
        default:
            icon = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/website-icon.png";
    }

    return <img onClick={props.onClick ? props.onClick : null} src={icon} alt={`${platform} icon`} style={{  ...props?.style, display: "flex", width: props.size ? props.size+"px" : "40px", height: props.size ? props.size+"px" : "40px", objectFit: "contain" }} />;
};

export default SocialLinkIcon;
